import Bowser from 'bowser';
import {AnalyticsService} from 'src/analytics';
import {ANALYTICS_SCHEDULAR_BOOKING_EVENTS} from './tracking-events';
import {isBrowserSupported} from '../utils/browser';


export const trackBrowserDetails = (agencyId: string, agencyName: string) => {
  const browserSupported = isBrowserSupported();
  const userAgent = window.navigator.userAgent;
  const browserDetails = Bowser.parse(userAgent);
  AnalyticsService.track(
    ANALYTICS_SCHEDULAR_BOOKING_EVENTS.BOOKING_BROWSER_DETAILS,
    {
      'Agency id': agencyId,
      'Agency name': agencyName,
      'Browser details': browserDetails,
      'User agent': userAgent,
    },
  );

  if (!browserSupported) {
    AnalyticsService.track(
      ANALYTICS_SCHEDULAR_BOOKING_EVENTS.BOOKING_UNSUPPORTED_BROWSER_DETECTED,
      {
        'Agency id': agencyId,
        'Agency name': agencyName,
        'Browser details': browserDetails,
        'User agent': userAgent,
      },
    );
  }
};
